/**
 * JobListing — Contentful placeholder block for the careers page.
 *
 * Follows the same pattern as ProductDetail and ProductListing:
 * placed in a Contentful Page's mainRegionCollection so CMS editors can add
 * content blocks above and below it. Data is fetched client-side from the
 * JobAdder API via /server/jobs (no SFCC/PageContext dependency).
 *
 * Requirements:
 * - JA-004: Job listing component
 * - AC-1: KL Careers landing page
 */

import React from 'react';

import PropTypes from 'prop-types';

import {CareersJobBoard} from '@amblique/king-living/app/components/careers';

export const JobListing = () => <CareersJobBoard showEdgePadding />;

JobListing.displayName = 'JobListing';
JobListing.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
